import React from 'react';
import PropTypes from 'prop-types';
import { decodeCCList, extractCompanyPayload } from '../../../../helpers/companies';
import { labels } from '../../../../constants/text';
import Loader from '../../../common/ui/Loader';
import ActionsGroup from '../../../common/ui/ItemActions';
import Validator from '../../../common/forms/Validator';
import ErrorMessage from '../../../common/forms/ErrorMessage';
import SwitchRow from '../../../common/forms/SwitchRow';

export default class CompanyDetails extends Validator {
  state = {
    ...this.props.company,
    edit: false,
    isLoading: false
  };

  validationRules = {
    company_name: { required: true },
    address: { required: true },
    city: { required: true },
    state: { required: true },
    zip: { zipcode: true }
  };

  handleCCInvoices = () => {
    if (this.props.company.cc_invoices) {
      this.setState({ cc_invoices: decodeCCList(this.props.company.cc_invoices) });
    }
  };

  enterEditMode = () => this.setState({ edit: true });

  exitEditMode = () => {
    this._resetErrors();
    this.setState({ edit: false, isLoading: false, ...this.props.company });
  };

  saveAndExit = event => {
    event.preventDefault();

    if (this.validate(this.validationRules)) {
      this.setState({ isLoading: true });

      const { company: { id }, editCompanyAction } = this.props;

      editCompanyAction(id, extractCompanyPayload(this.state))
        .then(this.exitEditMode);
    }
  };

  // hideAndExit = event => {
  //   console.log('hideme');
  //   this.handleHideSwitch('hide');
  //     if (this.validate(this.validationRules)) {
  //         this.setState({ isLoading: true, hide: true });
  //         const { company: { id }, editCompanyAction } = this.props;
  //
  //         editCompanyAction(id, extractCompanyPayload(this.state))
  //           .then(this.props.history.push(`/app/companies`));
  //     }
  // };

  onChange = event => this.setState({ [event.target.name]: event.target.value });

  handleSwitch = name => {
    if (this.state.edit) {
      this.setState(prevState => ({ [name]: !prevState[name] }));
    }
  };

  handleHideSwitch = name => {
    if (this.state.edit) {
      this.props.UIShowConfirm('Are you sure you want to hide this Company from all views and searches?', () => {
        this.setState({ hide: true });
        console.log('Hiding...');
      });
    }
  };

  componentDidMount () {
    this.handleCCInvoices();
  }

  render () {
    const { edit, company_name, address, city, state, zip, net_terms, cc_invoices, is_individual, is_cc_exempt,
      use_custom_rate, allow_1099m_workers, is_lta, checkin_verification_allowed, isLoading, hide,
      owner_id, owner_first_name, owner_last_name, owner_email } = this.state;
    const viewCCInvoices = cc_invoices ? decodeCCList(cc_invoices) : '';
    const errors = this.validationErrors;
    return (
      <form onSubmit={this.saveAndExit} className='company-details'>
        <div className={`form-group d-flex justify-content-between ${edit ? 'flex-column-reverse' : ''}`}>
          <div className='company-form'>
            <div className={!edit ? 'ui-disabled' : ''}>
              <div className='form-group'>
                <SwitchRow onChange={() => this.handleHideSwitch('hide')} checked={hide} label='Hide?' />
              </div>
            </div>
            {edit ? (
              <div>
                <strong>Company Name:</strong>
                <input onChange={this.onChange} autoFocus className='input' name='company_name' value={company_name || ''} />
                <ErrorMessage errorText={errors.company_name} />
              </div>
            ) : (
              <React.Fragment>
                <div className='form-group'>
                  <div>
                    <strong>Account Owner: </strong>
                    <p>{owner_first_name} {owner_last_name} ({owner_email}) [{owner_id}]</p>
                  </div>
                </div>
                <div className='form-group'>
                  <div>
                    <strong>Billing Address: </strong>
                    <p>{address} {city} {state} {zip}</p>
                  </div>
                </div>
              </React.Fragment>
            )}
          </div>

          <div className='company-actions text-right'>
            <ActionsGroup isLoading={isLoading} isEditing={edit} enterEditMode={this.enterEditMode} exitEditMode={this.exitEditMode} />
          </div>
        </div>
        {edit && (
          <React.Fragment>
            <div className='form-group'>
              <strong>Address: </strong>
              <input onChange={this.onChange} className='input' name='address' value={address || ''} />
              <ErrorMessage errorText={errors.address} />
            </div>
            <div className='form-group'>
              <strong>City: </strong>
              <input onChange={this.onChange} className='input' name='city' value={city || ''} />
              <ErrorMessage errorText={errors.city} />
            </div>
            <div className='form-group'>
              <strong>State: </strong>
              <input onChange={this.onChange} className='input' name='state' value={state || ''} />
              <ErrorMessage errorText={errors.state} />
            </div>
            <div className='form-group'>
              <strong>Zip: </strong>
              <input onChange={this.onChange} type='number' className='input' name='zip' value={zip || ''} />
              <ErrorMessage errorText={errors.zip} />
            </div>
          </React.Fragment>
        )}
        <div className='form-group'>
          <strong>Net Terms: </strong>
          {edit ? (
            <input onChange={this.onChange} type='number' className='input' name='net_terms' value={net_terms || ''} />
          ) : (
            <p>{net_terms || 'Not specified'}</p>
          )}
        </div>
        <div className='form-group'>
          <strong>CC on Invoice Email: </strong>
          {edit ? (
            <div>
              <div className='text-muted'>Please enter a comma-separated list of emails</div>
              <input onChange={this.onChange} className='input' name='cc_invoices' value={viewCCInvoices} />
            </div>
          ) : (
            <p>{viewCCInvoices || 'Not Specified'}</p>
          )}
        </div>

        <div className={!edit ? 'ui-disabled' : ''}>
          <div className='form-group'>
            <SwitchRow onChange={() => this.handleSwitch('is_individual')} checked={is_individual} label='Is Private Party?' />
          </div>
          <div className='form-group'>
            <SwitchRow onChange={() => this.handleSwitch('is_cc_exempt')} checked={is_cc_exempt} label='Credit Card Not Required' />
          </div>
          <div className='form-group'>
            <SwitchRow onChange={() => this.handleSwitch('use_custom_rate')} checked={use_custom_rate} label={`Use Custom ${labels.cost_rate}`} />
          </div>
          <div className='form-group'>
            <SwitchRow onChange={() => this.handleSwitch('allow_1099m_workers')} checked={allow_1099m_workers} label='Allow 1099M Workers' />
          </div>
          <div className='form-group'>
            <SwitchRow onChange={() => this.handleSwitch('is_lta')} checked={is_lta} label='Long-term Assignment (LTA)' />
          </div>
          <div className='form-group'>
            <SwitchRow onChange={() => this.handleSwitch('checkin_verification_allowed')} checked={checkin_verification_allowed} label='Check In Verification Allowed' />
          </div>
        </div>

        {/* <div className='company-actions text-right'> */}
        {/*  <button */}
        {/*    key='hideCompany' */}
        {/*    className='button button-primary fa-w-10' */}
        {/*    onClick={this.hideAndExit} */}
        {/*  >Hide</button> */}
        {/* </div> */}

        { isLoading && <Loader /> }
      </form>
    );
  }
}

CompanyDetails.propTypes = {
  company: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/app/companyDetails/Tabs/Details.js